import actionTypes from './actions/actionTypes';

const {REQUEST_TRANSCRIPTIONS, RECEIVE_TRANSCRIPTIONS, RESET_SEARCH} = actionTypes;

const initialState = {
  isFetchingTranscriptions: false,
  transcriptions: [],
  hasServerError: false,
  errors: {},
  success: false,
  message: ''
}

const transcriptionReducer = (state = initialState, action) => {
  switch(action.type) {
    case REQUEST_TRANSCRIPTIONS:
      return Object.assign({}, state, {
        isFetchingTranscriptions: true,
        hasServerError: false,
        errors: {},
        success: false,
        message: ''
      });
    case RECEIVE_TRANSCRIPTIONS:
      const transcriptions = action.roomRecordings.filter(r => {
        if(r && r.google_stt){
          const googleStt = JSON.parse(r.google_stt);
          if(googleStt.length > 0) {
            return r;
          }
        }
      })
      return Object.assign({}, state, {
        isFetchingTranscriptions: false,
        transcriptions
      });
    case RESET_SEARCH:
      return Object.assign({}, state, {
        isFetchingTranscriptions: false,
        transcriptions: []
      })
    default:
      return state;
  }
}

export default transcriptionReducer;


// WEBPACK FOOTER //
// src/routes/Transcriptions/reducer.js